<template>
  <div v-for="[key, item] in Array.from(items.entries()).sort((a, b) => a[1].description < b[1].description ? -1 : 1)"
       :key="key">
    <v-list-group v-if="(item.type === 'group') || (item.type === 'subgroup')" :key="item.code" :value="item.code">
      <template v-slot:activator="{ isOpen, props }">
        <v-list-item v-bind="props" prepend-icon="mdi-file-document"
                     :title="item.description + ' (' + item.code + ')'"
                     @click.stop="item.clinicalTrialsExist === true ? $router.push(({name: 'ClinicalTrials', params: {
                       mesh: item.code,
                       meshPresentation: item.code,
                       meshDescription: item.description}})) : null">
          <template v-slot:append>
            <v-icon v-bind="props" :icon="isOpen?'mdi-chevron-up':'mdi-chevron-down'"/>
          </template>
        </v-list-item>
      </template>
      <v-lazy transition="fade-transition">
        <div>
          <RecursiveClinicalTrialsMenu :items="item.children"></RecursiveClinicalTrialsMenu>
          <v-divider v-if="item.type === 'group'"></v-divider>
        </div>
      </v-lazy>
    </v-list-group>
    <v-list-item  v-if="item.type === 'leaf'"
                  :key="item.code"
                  :value="item.code"
                  :title="item.description + ' (' + item.code + ')'"
                  @click="$router.push(({name: 'ClinicalTrials', params: {
                                      mesh: item.code,
                                      meshPresentation: item.code,
                                      meshDescription: item.description}}))">
    </v-list-item>
  </div>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'RecursiveClinicalTrialsMenu',
  props: {
    items: Map
  }
});
</script>
